import styled from "styled-components";
import { typography } from "dab-component-lib";
import {
  MediaStyle,
  GridRowStyle,
  GridColStyle,
  basic,
} from "../../../utils/style-utils";

export const FooterStyle = styled.footer`
  background-color: ${basic.secondary};
  border-top: 1px solid #e7e7e7;
  color: white;
  margin-top: 30px;
  // left:0;
  // bottom:0;
  // height: 60px;
  // width: 100%;
  // position: fixed;
  ${MediaStyle.lg`
    margin-top: 60px;
  `}
`;

export const FooterRowStyle = GridRowStyle.extend`
  flex-direction: column-reverse;
  ${MediaStyle.lg`
    flex-direction: row;
  `}
`;

export const FooterColStyle = GridColStyle.extend`
  p {
    ${typography.Caption1}
    a {
      color: white;
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
  }
`;

export const SocialContainerStyle = styled.div`
  display: flex;
  margin-top: 15px;
  ${MediaStyle.lg`
    margin-top: 0;
  `}
`;

export const SocialLinkStyle = styled.a`
  display: block;
  margin: 0 2px;
`;

export const LinkStyle = styled.a`
  ${typography.Small1}
  color: ${basic.white};
  text-align: left;
  text-decoration: none;
  margin-right: 1rem;

  ${(props) =>
    props.onClick &&
    `
    cursor: pointer;
  `}
`;



// WEBPACK FOOTER //
// ./src/components/common/footer/style.js